import type { StatCard as StatCardModel } from '../../../../types'
import { cn } from '../../../../utils/cn'
import { LimeChip } from '../../../../components/ui/LimeChip'
import { OpenIndicator } from '../../../../components/ui/OpenIndicator'
import { StatGlyph } from '../../../../components/ui/StatGlyph'
import { TrendBadge } from '../../../../components/ui/TrendBadge'

type StatCardProps = {
  stat: StatCardModel
  /** `highlight` is the gradient card that leads the row. */
  variant?: 'default' | 'highlight'
}

export const StatCard = ({ stat, variant = 'default' }: StatCardProps) => {
  const highlight = variant === 'highlight'

  return (
    <article
      className={cn(
        'flex h-[122px] flex-col justify-center gap-[6px] rounded-[12px] px-[20px]',
        highlight ? 'bg-dash-highlight' : 'bg-dash-card shadow-dash-card',
      )}
    >
      <div className="flex items-start justify-between gap-[34px]">
        <div className="flex min-w-0 flex-col items-start gap-[6px]">
          <p
            className={cn(
              'font-host text-[16px] font-medium leading-normal',
              highlight ? 'text-white' : 'text-dash-heading',
            )}
          >
            {stat.label}
          </p>

          <div className={cn('flex items-center', highlight ? 'gap-[7px]' : 'gap-[10px]')}>
            <LimeChip size={stat.chipSize}>
              <StatGlyph
                icon={stat.icon}
                glyphSize={stat.glyphSize}
                flipped={stat.flipped}
                glyphInset={stat.glyphInset}
              />
            </LimeChip>
            <p
              className={cn(
                'font-poppins text-[20px] font-medium leading-normal',
                highlight ? 'text-white' : 'text-black',
              )}
            >
              {stat.value}
            </p>
          </div>
        </div>

        <OpenIndicator />
      </div>

      <div className="flex items-center gap-[4px]">
        {stat.showTrend && <TrendBadge />}
        <p
          className={cn(
            'whitespace-nowrap font-host text-[14px] font-normal leading-normal',
            highlight ? 'text-white' : 'text-dash-body',
          )}
        >
          {stat.caption}
        </p>
      </div>
    </article>
  )
}
